"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgShieldFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 22c.587 0 1.1-.32 1.1-.32 1.792-1.173 3.09-2.542 3.897-3.337C18.467 16.893 20 14.229 20 12V7.008s.026-.524-.287-1.035a1.934 1.934 0 00-.817-.755l-6-3.007A2.092 2.092 0 0012 2c-.299 0-.598.07-.896.21l-6 3.008a2.297 2.297 0 00-.781.755C4 6.465 4 7.006 4 7.006V12c0 2.253 1.502 4.889 3 6.343.808.783 2.114 2.154 3.918 3.343 0 0 .495.314 1.082.314z' }))); };
exports.default = SvgShieldFilled;
//# sourceMappingURL=ShieldFilled.js.map